/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_AccessoriesInputs */

const en_val_accessories = /** @type {(inputs: Val_AccessoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accessories`)
};

const es_val_accessories = /** @type {(inputs: Val_AccessoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accesorios`)
};

const fr_val_accessories = /** @type {(inputs: Val_AccessoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accessoires`)
};

const de_val_accessories = /** @type {(inputs: Val_AccessoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accessoires`)
};

const ja_val_accessories = /** @type {(inputs: Val_AccessoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アクセサリー`)
};

const zh_val_accessories = /** @type {(inputs: Val_AccessoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`配饰`)
};

const ar_val_accessories = /** @type {(inputs: Val_AccessoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إكسسوارات`)
};

const id_val_accessories = /** @type {(inputs: Val_AccessoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aksesoris`)
};

const it_val_accessories = /** @type {(inputs: Val_AccessoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accessori`)
};

const ru_val_accessories = /** @type {(inputs: Val_AccessoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Аксессуары`)
};

const pt_val_accessories = /** @type {(inputs: Val_AccessoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acessórios`)
};

const ko_val_accessories = /** @type {(inputs: Val_AccessoriesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`액세서리`)
};

/**
* | output |
* | --- |
* | "Accessories" |
*
* @param {Val_AccessoriesInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_accessories = /** @type {((inputs?: Val_AccessoriesInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_AccessoriesInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_accessories(inputs)
	if (locale === "es") return es_val_accessories(inputs)
	if (locale === "fr") return fr_val_accessories(inputs)
	if (locale === "de") return de_val_accessories(inputs)
	if (locale === "ja") return ja_val_accessories(inputs)
	if (locale === "zh") return zh_val_accessories(inputs)
	if (locale === "ar") return ar_val_accessories(inputs)
	if (locale === "id") return id_val_accessories(inputs)
	if (locale === "it") return it_val_accessories(inputs)
	if (locale === "ru") return ru_val_accessories(inputs)
	if (locale === "pt") return pt_val_accessories(inputs)
	return ko_val_accessories(inputs)
});